import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone'
import { Box, Button, Typography } from '@mui/material'
import I18n from 'i18n-js'
import { AuthLayout } from '../../components/authLayout'
import { Fr, Pt, Es, En } from '../../locale'

const APP_STORE_URL = 'https://apps.apple.com/app/com.idpsante.patient'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.idpsante.patient'

const SUPPORTED_LOCALES = ['fr', 'es', 'en', 'pt']

function getBrowserLocale() {
  const lang = (navigator.language || 'fr').split('-')[0].toLowerCase()
  return SUPPORTED_LOCALES.includes(lang) ? lang : 'fr'
}

export default function Invitation() {
  I18n.translations = { fr: Fr, pt: Pt, es: Es, en: En }
  I18n.locale = getBrowserLocale()
  I18n.fallbacks = true

  return (
    <AuthLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          py: 2,
          gap: 2,
        }}
      >
        <PhoneIphoneIcon sx={{ fontSize: 56, color: 'primary.main' }} />
        <Typography variant="h6" fontWeight={600}>
          {I18n.t('invitation.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 320 }}>
          {I18n.t('invitation.body')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center', mt: 1 }}>
          <Button
            variant="contained"
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textTransform: 'none', minWidth: 140 }}
          >
            App Store
          </Button>
          <Button
            variant="outlined"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textTransform: 'none', minWidth: 140 }}
          >
            Google Play
          </Button>
        </Box>
      </Box>
    </AuthLayout>
  )
}
